import {
  Component,
  OnInit,
  AfterViewChecked,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextsTodo } from 'projects/speaker-platform/src/app/types/texts-todo.enum';
import { TextsMenuComponent } from 'projects/speaker-platform/src/app/molecules/texts-menu/texts-menu.component';
import { AbstractTextComponent } from '../../../common/abstract/abstract-texts.component';
import { AtsappService } from '@common/services/atsapp.service';
import { FiltersProps } from 'projects/speaker-platform/src/app/types/filters';
import { takeUntil } from 'rxjs';
import { TextsListFiltersComponent } from 'projects/speaker-platform/src/app/organisms/admin/texts-list-filters/texts-list-filters.component';
import { DateTransformService } from 'projects/speaker-platform/src/app/services/helpers/date-transform.service';
import { TextsListTaxonomy } from 'projects/speaker-platform/src/app/types/texts-list-taxonomy.enum';
import { PaginationComponent } from 'projects/speaker-platform/src/app/molecules/pagination/pagination.component';
import { DialogComponent } from 'projects/speaker-platform/src/app/molecules/dialog/dialog.component';
import { LoaderComponent } from '@common/components/loader/loader.component';
import { SpeakerService } from 'projects/speaker-platform/src/app/services/helpers/speaker.service';
import { TextsActions } from 'projects/speaker-platform/src/app/types/texts-actions.enum';
import { PostStatesComponent } from 'projects/speaker-platform/src/app/molecules/post-states/post-states.component';
import { Speaker } from '../../../types/speaker';
import { CcLibelleService } from '../../../services/helpers/cc-libelle-service.service';
import {NgbModal, NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import { TruncatePipe } from '../../../pipes/truncate.pipe';
import {TextFocusComponent} from "../../../organisms/text-focus/text-focus.component";
import {CommonModalService} from "../../../services/helpers/common-modal.service";

@Component({
  selector: 'app-texts-translate-sent',
  imports: [
    CommonModule,
    TextsMenuComponent,
    TextsListFiltersComponent,
    PaginationComponent,
    DialogComponent,
    LoaderComponent,
    PostStatesComponent,
    NgbTooltip,
    TruncatePipe,
    TextFocusComponent,
  ],
  templateUrl: './texts-translate-sent.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../organisms/admin/texts-list/texts-list.component.scss']
})
export class TextsTranslateSentComponent
  extends AbstractTextComponent
  implements OnInit, AfterViewChecked
{
  constructor(
    atsappService: AtsappService,
    dateTransformService: DateTransformService,
    protected speakerService: SpeakerService,
    ccLibelleService: CcLibelleService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private commonModalService: CommonModalService,
  ) {
    super(atsappService, dateTransformService, ccLibelleService);
  }

  @ViewChild('textsListHeader') textsListHeader!: ElementRef;
  textsTodo = TextsTodo;
  sentTextsToTranslateList: any[] = [];
  selectedSpeaker!: Speaker;
  textsListTaxonomy = TextsListTaxonomy;

  smartSelectEnabled: boolean = false;

  isPosting: boolean = false;
  isPostingOver: boolean = false;
  postError: { errorCode: number; message: string } | null = null;
  showValidationDialog: boolean = false;

  page: number = 1;
  limit: number = 10;
  collectionSize: number = 0;

  actions = TextsActions;

  filters: any[] = [];

  textsListHeaderHeight: string = '';

  postObjectKeys = [
    'RANGPV',
    'ZMS_NUMERO',
    'ZMS_LIVRAISON',
    'ZMS_MESSAGE',
    'ZMS_PVENVOITRAD1',
    'ZMS_LANGUE',
    'ZMS_PVTRAD1'
  ];

  textsForPreview: any[] = [];

  showFocusModalTranslated: boolean = false;

  ngOnInit(): void {
    this.getPhasesVocale();
    this.getTypesMessage();
    this.getLangues();
    this.getTranslator();
  }

  ngAfterViewChecked(): void {
    this.textsListHeaderHeight =
      this.textsListHeader.nativeElement.clientHeight + 'px';
    this.cdr.detectChanges();
  }

  getSentTextsToTranslateList(filters: any = this.filters) {
    this.isLoading = true;
    this.filters = filters;
    this.atsappService
      .getSentTextsToTranslate(this.filters, this.page, this.limit)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.sentTextsToTranslateList = res.texts_to_translate_sent;
          this.collectionSize = parseInt(res.total);
          this.isLoading = false;
        },
        error: (err) => console.error(err),
        complete: () => this.resetTextsToPatchList(),
      });
  }

  exportTextTranslated(filters: any = this.filters) {
    this.isLoading = true;
    this.filters = filters;
    this.atsappService
      .getSentTextsToTranslate(this.filters, 1, 1000000)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.texts_to_translate_sent.length > 0) {
            this.sentTextsToTranslateList = res.texts_to_translate_sent;
            this.collectionSize = parseInt(res.total);
            this.createExcelExportData(res.texts_to_translate_sent);
          }
          this.isLoading = false;

        },
        error: (err) => console.error(err),
        complete: () => this.resetTextsToPatchList(),
      });
  }

  openConfirmationDialog() {
    this.postError = null;
    this.isPosting = false;
    this.isPostingOver = false;
    this.showValidationDialog = !this.showValidationDialog;
  }

  sendTexts(notify: boolean = false) {
    // Object to POST
    const body = {
      email: notify,
      TRANSLATIONS: this.textsToPatchList,
    };

    this.atsappService
      .unassignTranslations(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: (error) => {
          this.playErrorSound();
          this.postError = {
            errorCode: error.error.code,
            message: error.error.message,
          };
          this.isPosting = false;
        },
        complete: () => {
          this.postError = null;
          this.isPostingOver = true;
          this.isPosting = false;
          this.resetTextsToPatchList();
          this.playSuccessSound();
        },
      });
  }

  filterSelectedText() : any[] {
    this.textsForPreview =[]
    return this.sentTextsToTranslateList.filter(allTranslateText => {
      return this.textsToPatchIdList.some(textToSee => {
        const partialIdText = textToSee.split('-')
        return partialIdText[0] === allTranslateText.ZMS_NUMERO && partialIdText[1] === allTranslateText.ZMS_LIVRAISON && partialIdText[2] === allTranslateText.ZMS_MESSAGE && partialIdText[3]=== allTranslateText.RANGPV && partialIdText[4] ===allTranslateText.CLIENT_FINAL
      })
    });
  }

  showSelectedText(content : TemplateRef<any>) {
    this.textsForPreview = this.filterSelectedText()
    this.modalService.open(content, { size: 'xl', scrollable: true , centered: true})
  }

  showFocusTranslatedText(text: any) {
    this.commonModalService.showModalFocus.subscribe((show) => {
      this.showFocusModalTranslated = show;
    })
    this.commonModalService.openFocusText(text)
  }

  onSmartSelectEnable() {}
}
